module.exports = __webpack_public_path__ + "img/visiting-icon.dd8ca66d.png";